import type { FC } from "react"

import styled from "styled-components"

import ToggleButton from "~/components/ToggleButton"
import { DEPRECATED_ModuleSelectionDropdown as ModuleSelectionDropdown } from "~/containers/Proposal/Setup/Form/Steps/ModuleSelection"
import { useDesignContext } from "~/containers/Proposal/state/designs/design-context"
import { useProposalContext } from "~/containers/Proposal/state/proposal/proposal-context"

import { ReactComponent as XIcon } from "@svg/x.svg"

import { Buttons, Header, Wrapper } from "./styles"

const MountingSelection = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-s);
  max-width: fit-content;
  p {
    text-transform: capitalize;
    color: #5e676c;
  }
  > div {
    justify-content: flex-end;
    flex-direction: row-reverse;
  }
  h3 {
    font-size: var(--step--2);
    text-transform: capitalize;
    font-weight: 600;
  }
`

export const EditInfo: FC<{
  close: VoidFunction
}> = ({ close }) => {
  const {
    save: saveDesign,
    isSaving: designIsSaving,
    resetLocal: resetDesign,
  } = useDesignContext()
  const {
    reset,
    save,
    isLoading,
    local: { systemType },
    changeLocal,
  } = useProposalContext()
  const handleClose = async () => {
    resetDesign()
    reset()
    close()
  }
  const handleSave = async () => {
    await save()
    await saveDesign()
    close()
  }
  const isSaving = isLoading || designIsSaving

  return (
    <Wrapper isSaving={isSaving}>
      <Header>
        <h1>Edit Information</h1>
        <XIcon onClick={handleClose} />
      </Header>
      <ModuleSelectionDropdown />
      <MountingSelection>
        <h3>Mounting Type</h3>
        <ToggleButton
          label={`Roof`}
          setAction={() => changeLocal({ systemType: `roof_mount` })}
          isActive={systemType === `roof_mount`}
        />
        <ToggleButton
          label={`Ground`}
          setAction={() => changeLocal({ systemType: `ground_mount` })}
          isActive={systemType === `ground_mount`}
        />
        <ToggleButton
          label={`Both`}
          setAction={() => changeLocal({ systemType: `both` })}
          isActive={systemType === `both`}
        />
      </MountingSelection>
      <Buttons>
        <button onClick={handleSave}>update</button>
        <button onClick={handleClose}>Cancel</button>
      </Buttons>
    </Wrapper>
  )
}
